import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { Grid } from "@material-ui/core";

const AddUpdateClose = ({ changeState }) => {
  const handleClick = () => {
    changeState({ page: "pageList", refetch: true });
  };
  return (
    <Grid container direction="row" justify="flex-end" alignItems="center">
      <span>
        <Tooltip title={"Kapat"}>
          <IconButton onClick={handleClick}>
            <HighlightOffIcon />
          </IconButton>
        </Tooltip>
      </span>
    </Grid>
  );
};

export default AddUpdateClose;
